import { render, staticRenderFns } from "./Register.vue?vue&type=template&id=295f8e48"
import script from "./Register.vue?vue&type=script&lang=js"
export * from "./Register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('295f8e48')) {
      api.createRecord('295f8e48', component.options)
    } else {
      api.reload('295f8e48', component.options)
    }
    module.hot.accept("./Register.vue?vue&type=template&id=295f8e48", function () {
      api.rerender('295f8e48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Register.vue"
export default component.exports